import React, { Component } from "react";
import { Spin } from "../GeneralComponents/ui";

import "./SplashScreen.css";
import i18n from "../../Utils/i18next";

export default class SplashScreen extends Component {
  render() {
  let style = this.props.style ? {...this.props.style} : {}
  style.display = this.props.display ? {...this.props.display} : "none"
    return (
      <div id={this.props.id ? this.props.id : "splashScreenContainer"} style={style}>
        <div className="logo-animate">
          <div className="bar">
            <div className="triangle-up"></div>
            <div className="triangle-down"></div>
          </div>
          <div className="bar">
            <div className="triangle-up"></div>
            <div className="triangle-down"></div>
          </div>
          <div className="bar">
            <div className="triangle-up"></div>
            <div className="triangle-down"></div>
          </div>
          <div className="bar">
            <div className="parallelogram">
              <div></div>
            </div>
          </div>
          <div className="text">
            <span>{`${i18n.t("Splash.Loading")}...`}</span>
          </div>
        </div>
      </div>
    );
  }
}
